export const SHOW_ERROR_POPUP = 'SHOW_ERROR_POPUP';
export const HIDE_ERROR_POPUP = 'HIDE_ERROR_POPUP';
export const RETRY_FAILED_ACTION = 'RETRY_FAILED_ACTION';
export const ERROR_TYPE = {
  ORDER: 'order',
  ORDER_3DS: 'order_3ds',
  PREBUILD: 'prebuild',
};
